import { getTheme, getChannelColor as getColor } from '../../config/clientConfig';

var channelToColor = function(channelName){
    return getColor(channelName);
}

// For backward compatibility - builds the mapping object
function getChannelToColorMap() {
    const theme = getTheme();
    return {
        "social": theme.channels.social.color,
        "highlights": theme.channels.highlights.color,
        "digital": theme.channels.digital.color,
        "linear": theme.channels.linear.colorAlt
    };
}

export { channelToColor, getChannelToColorMap }
